module.exports = __webpack_public_path__ + "assets/img/line.6631376d.svg";